import { render, staticRenderFns } from "./InformacionContribuyente.vue?vue&type=template&id=e2239620&scoped=true"
import script from "./InformacionContribuyente.vue?vue&type=script&lang=js"
export * from "./InformacionContribuyente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2239620",
  null
  
)

export default component.exports